import type { File } from "$lib/wasm/file";
import { PreviewCanvas } from "svelte-pixel-editor-wasm";

const previewCanvases: Record<number, PreviewCanvas> = {};

export function getCanvas(file: File) {
    const id = file.id!;
    return (previewCanvases[id] ??= PreviewCanvas.new(file.width, file.height));
}
